// import "../styles/Contact.css";
// import emailjs from "@emailjs/browser";
// import { useRef } from "react";

// export default function Contact() {
//   const form = useRef();

//   const sendEmail = (e) => {
//     e.preventDefault();

//     emailjs
//       .sendForm("service_ucuwc2c", "template_amvmebg", form.current, {
//         publicKey: "vzC6o9k1z8wj0__yq",
//       })
//       .then(
//         () => {
//           alert("Message sent successfully!");
//           form.current.reset();
//         },
//         (error) => {
//           alert("Failed to send message.");
//           console.log(error.text);
//         },
//       );
//   };

//   return (
//     <section className="contact-page">
//       <div className="container">
//         {/* Header */}
//         <div className="contact-header">
//           <span className="contact-badge">CONTACT JAT TECHNOCRAFT</span>

//           <h1>
//             Let’s Build <span>Together</span>
//           </h1>

//           <p>
//             Connect with our team for OEM manufacturing, AC assembly solutions,
//             and industrial partnerships.
//           </p>
//         </div>

//         <div className="row g-4 align-items-stretch">
//           {/* Left Side */}
//           <div className="col-lg-5">
//             <div className="contact-info">
//               <h3>Get In Touch</h3>

//               <div className="info-card">
//                 <div className="info-icon">📍</div>

//                 <div>
//                   <h5>Our Address</h5>

//                   <p>
//                     PLOT NO. H-31/1, MIDC WALUJ,
//                     <br />
//                     AURANGABAD – 431133
//                   </p>
//                 </div>
//               </div>

//               <div className="info-card">
//                 <div className="info-icon">📞</div>

//                 <div>
//                   <h5>Phone Number</h5>
//                   <p>+91-XXXXXXXXXX</p>
//                 </div>
//               </div>

//               <div className="info-card">
//                 <div className="info-icon">📧</div>

//                 <div>
//                   <h5>Email Address</h5>
//                   <p>info@jattechnocraft.com</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Side */}
//           <div className="col-lg-7">
//             <form ref={form} onSubmit={sendEmail} className="contact-form">
//               <div className="row">
//                 <div className="col-md-6 mb-4">
//                   <input
//                     type="text"
//                     name="from_name"
//                     className="form-control"
//                     placeholder="Your Name"
//                     required
//                   />
//                 </div>

//                 <div className="col-md-6 mb-4">
//                   <input
//                     type="email"
//                     name="from_email"
//                     className="form-control"
//                     placeholder="Your Email"
//                     required
//                   />
//                 </div>
//               </div>

//               {/* SUBJECT FIELD */}
//               <div className="mb-4">
//                 <input
//                   type="text"
//                   name="subject"
//                   className="form-control"
//                   placeholder="Subject"
//                   required
//                 />
//               </div>

//               <div className="mb-4">
//                 <textarea
//                   name="message"
//                   className="form-control"
//                   rows="6"
//                   placeholder="Write your message..."
//                   required
//                 ></textarea>
//               </div>

//               <button type="submit" className="contact-btn">
//                 Send Message →
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Map */}
//         <div className="map-section">
//           <iframe
//             title="location-map"
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3752.659575350722!2d75.20516297512633!3d19.854352027077084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdb9a53fadadec1%3A0x774cc5f1da639653!2sJAT%20METAL%20PRESSING%20LIMITED!5e0!3m2!1sen!2sin!4v1778214385067!5m2!1sen!2sin"
//             width="100%"
//             height="450"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//           ></iframe>
//         </div>
//       </div>
//     </section>
//   );
// }













import "../styles/Contact.css";
import emailjs from "@emailjs/browser";
import { useRef } from "react";

export default function Contact() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ucuwc2c",
        "template_amvmebg",
        form.current,
        {
          publicKey: "vzC6o9k1z8wj0__yq",
        }
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("Failed to send message.");
          console.log(error.text);
        }
      );
  };

  return (
    <section className="contact-page">

      {/* HERO HEADER */}
      <div className="contact-header">

        <div className="container">

          <span className="contact-badge">
            CONTACT JAT TECHNOCRAFT
          </span>

          <h1>
            Let’s Build <span>Together</span>
          </h1>

          <p>
            Connect with our team for OEM manufacturing,
            AC assembly solutions, and industrial partnerships.
          </p>

        </div>

      </div>

      <div className="container">

        <div className="row g-4 align-items-stretch">

          {/* LEFT SIDE */}
          <div className="col-lg-5">

            <div className="contact-info">

              <h3>Get In Touch</h3>

              <div className="info-card">

                <div className="info-icon">📍</div>

                <div>
                  <h5>Our Address</h5>

                  <p>
                    PLOT NO. H-31/1, MIDC WALUJ,
                    <br />
                    CHHATRAPATI SAMBHAJINAGAR – 431133
                  </p>
                </div>

              </div>

              <div className="info-card">

                <div className="info-icon">📞</div>

                <div>
                  <h5>Phone Number</h5>
                  <p>+91-XXXXXXXXXX</p>
                </div>

              </div>

              <div className="info-card">

                <div className="info-icon">📧</div>

                <div>
                  <h5>Email Address</h5>
                  <p>info@jattechnocraft.com</p>
                </div>

              </div>

            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-7">

            <form
              ref={form}
              onSubmit={sendEmail}
              className="contact-form"
            >

              <div className="row">

                <div className="col-md-6 mb-4">

                  <input
                    type="text"
                    name="from_name"
                    className="form-control"
                    placeholder="Your Name"
                    required
                  />

                </div>

                <div className="col-md-6 mb-4">

                  <input
                    type="email"
                    name="from_email"
                    className="form-control"
                    placeholder="Your Email"
                    required
                  />

                </div>

              </div>

              <div className="mb-4">

                <input
                  type="text"
                  name="subject"
                  className="form-control"
                  placeholder="Subject"
                  required
                />

              </div>

              <div className="mb-4">

                <textarea
                  name="message"
                  className="form-control"
                  rows="6"
                  placeholder="Write your message..."
                  required
                ></textarea>

              </div>

              <button type="submit" className="contact-btn">
                Send Message →
              </button>

            </form>

          </div>

        </div>

        {/* MAP */}
        <div className="map-section">

          <iframe
            title="location-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3752.659575350722!2d75.20516297512633!3d19.854352027077084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdb9a53fadadec1%3A0x774cc5f1da639653!2sJAT%20METAL%20PRESSING%20LIMITED!5e0!3m2!1sen!2sin!4v1778214385067!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>

        </div>

      </div>

    </section>
  );
}